import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import { Status } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";

class MasterCabangFilter extends Component {
  statusOptions = [
    {
      label: Status.ACTIVE,
      value: Status.ACTIVE,
    },
    {
      label: Status.INACTIVE,
      value: Status.INACTIVE,
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      provinceOptions: [],
      wilayahOptions: [],
    };
  }

  async componentDidMount() {
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").getAllProvince(),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "WILAYAH_TYPE",
        },
      }),
    ]);

    if (responses[0].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        provinceOptions: responses[0].data.data.map((option) =>
          mapToObjectDDL(option.provinceName, option.id)
        ),
      }));
    }

    if (responses[1].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        wilayahOptions: responses[1].data.data.map((option) =>
          mapToObjectDDL(option.value, option.key)
        ),
      }));
    }
  }

  handleChangeProvince = async (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
        idKota: null,
        idKecamatan: null,
        kodePos: null,
      },
    }));
    if (!R.isNil(value)) {
      try {
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(value.value);
        if (response.ok) {
          this.props.onSetState((prevValue) => ({
            ...prevValue,
            kotaOptions: response.data.data.map((option) =>
              mapToObjectDDL(option.kabKotName, option.kabKotId)
            ),
          }));
        }
      } catch (error) {
        // TODO
      }
    }
  };

  handleChangeKota = async (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
        idKecamatan: null,
        kodePos: null,
      },
    }));
    if (!R.isNil(value)) {
      try {
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(value.value);
        if (response.ok) {
          this.props.onSetState((prevValue) => ({
            ...prevValue,
            kecamatanOptions: response.data.data.map((option) =>
              mapToObjectDDL(option.kecamatanName, option.id)
            ),
          }));
        }
      } catch (error) {
        // TODO
      }
    }
  };

  handleChangeKecamatan = async (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
        kodePos: null,
      },
    }));
    if (!R.isNil(value)) {
      try {
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(value.value);
        if (response.ok) {
          this.props.onSetState((prevValue) => ({
            ...prevValue,
            kelurahanOptions: response.data.data.map((option) => ({
              ...mapToObjectDDL(`${option.zipcode} - ${option.kelurahanname}`, option.zipcode),
              kelurahanId: option.id,
            })),
          }));
        }
      } catch (error) {
        // TODO
      }
    }
  };

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  getFilterDataValue = (fieldName, fallbackValue = "") => {
    return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
      ? this.props.state.filterData[fieldName]
      : fallbackValue;
  };

  render() {
    return (
      <SimpleModal
        title="Filter"
        visible={this.props.state.filterVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <div className="grid grid-2x grid-mobile-none gap-15px">
              <div id="grid-1">
                <SimpleInput
                  id="input_text_kode_cabang"
                  name="kodeCabang"
                  label="Kode Cabang"
                  value={this.getFilterDataValue("kodeCabang")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="input_text_dealerid"
                  name="ahmDealerCode"
                  label="Dealer ID"
                  value={this.getFilterDataValue("ahmDealerCode")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="input_text_nama_dealer"
                  name="namaDealer"
                  label="Nama Dealer"
                  value={this.getFilterDataValue("namaDealer")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="input_text_nama_pt"
                  name="namaPT"
                  label="Nama PT"
                  value={this.getFilterDataValue("namaPT")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />

                <SimpleInput
                  id="input_text_alamat"
                  name="alamat"
                  label="Alamat"
                  value={this.getFilterDataValue("alamat")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <div>
                  <h4 className="txt-site txt-11 txt-main">Coordinate</h4>
                  <FlexView style={{ gap: "10px" }}>
                    <SimpleInput
                      placeholder="Lat"
                      id="input_text_latitude"
                      name="latitude"
                      value={this.getFilterDataValue("latitude")}
                      onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                    />
                    <SimpleInput
                      placeholder="Long"
                      id="input_text_longitude"
                      name="longitude"
                      value={this.getFilterDataValue("longitude")}
                      onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                    />
                  </FlexView>
                </div>
                <SimpleDDL
                  id="select_options_provinsi"
                  name="idProvince"
                  label="Provinsi"
                  box="search"
                  isClearable
                  options={this.state.provinceOptions}
                  value={this.getFilterDataValue("idProvince", null)}
                  onChange={(value, { name }) => this.handleChangeProvince(name, value)}
                />
                <SimpleDDL
                  id="select_options_kota"
                  name="idKota"
                  label="Kota"
                  box="search"
                  isClearable
                  readOnly={
                    R.isNil(this.props.state.filterData.idProvince) ||
                    R.isEmpty(this.props.state.filterData.idProvince)
                  }
                  options={this.props.state.kotaOptions}
                  value={this.getFilterDataValue("idKota", null)}
                  onChange={(value, { name }) => this.handleChangeKota(name, value)}
                />
                <SimpleDDL
                  id="select_options_kecamatan"
                  name="idKecamatan"
                  label="Kecamatan"
                  box="search"
                  isClearable
                  readOnly={
                    R.isNil(this.props.state.filterData.idKota) ||
                    R.isEmpty(this.props.state.filterData.idKota)
                  }
                  options={this.props.state.kecamatanOptions}
                  value={this.getFilterDataValue("idKecamatan", null)}
                  onChange={(value, { name }) => this.handleChangeKecamatan(name, value)}
                />
                <SimpleDDL
                  id="select_options_kode_pos"
                  name="kodePos"
                  label="Kode Pos"
                  box="search"
                  isClearable
                  readOnly={
                    R.isNil(this.props.state.filterData.idKecamatan) ||
                    R.isEmpty(this.props.state.filterData.idKecamatan)
                  }
                  options={this.props.state.kelurahanOptions}
                  value={this.getFilterDataValue("kodePos", null)}
                  onChange={(value, { name }) => this.handleValueChange(name, value)}
                />
              </div>
              <div id="grid-2">
                <SimpleInput
                  id="text_input_email"
                  name="email"
                  label="Email"
                  value={this.getFilterDataValue("email")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="text_input_mdid"
                  name="kodeMD"
                  label="MD ID"
                  value={this.getFilterDataValue("kodeMD")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="text_input_npwp"
                  name="npwp"
                  label="NPWP"
                  value={this.getFilterDataValue("npwp")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleDDL
                  id="select_options_wilayah"
                  name="idWilayah"
                  label="Wilayah"
                  box="search"
                  options={this.state.wilayahOptions}
                  value={this.getFilterDataValue("idWilayah")}
                  onChange={(value, { name }) => this.handleValueChange(name, value)}
                />
                <SimpleInput
                  id="text_input_phone_bengkel"
                  name="phoneBengkel"
                  label="Phone Bengkel"
                  box="onlyNumber"
                  maxLength={14}
                  value={this.getFilterDataValue("phoneBengkel")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="text_input_phone_showroom"
                  name="phoneShowroom"
                  label="Phone Showroom"
                  box="onlyNumber"
                  maxLength={14}
                  value={this.getFilterDataValue("phoneShowroom")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="text_input_phone_crm"
                  name="phoneCRM"
                  label="Phone CRM"
                  box="onlyNumber"
                  maxLength={14}
                  value={this.getFilterDataValue("phoneCRM")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="text_input_facebook"
                  name="facebookName"
                  label="Facebook"
                  value={this.getFilterDataValue("facebookName")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />

                <SimpleInput
                  id="text_input_instagram"
                  name="instagramName"
                  label="Instagram"
                  value={this.getFilterDataValue("instagramName")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleDDL
                  id="select_options_status"
                  name="status"
                  label="Status"
                  box="search"
                  isClearable
                  options={this.statusOptions}
                  value={
                    !R.isNil(this.props.state.filterData) && this.props.state.filterData.status
                      ? this.props.state.filterData.status
                      : { label: Status.ACTIVE, value: Status.ACTIVE }
                  }
                  onChange={(value, { name }) => this.handleValueChange(name, value)}
                />
              </div>
            </div>
            <FlexView vAlignContent="center" hAlignContent="right">
              <SimpleButton type="button" secondary onClick={this.props.onReset}>
                Hapus
              </SimpleButton>
              <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default MasterCabangFilter;
